<script>
import DatepickerComponent from './Datepicker.vue'
import DropdownComponent from './Dropdown.vue'
import store from '../store'
import { get as getAvailability, getPartyParams } from '../services/availability'
import { getDateString, todayAt } from '../date'

export default {
    // state
    data () {
        return {
            // availability
            availability: null,
            isGettingAvailability: null,
            // date
            startDate: null,
            endDate: null,
            // property
            propertyRentalSourceId: null,
            // rate plan
            ratePlan: null,
            // room types
            roomType: null,
            roomTypeOptions: null,
            // user
            userId: null,
            points: null,
        }
    },
    props: {
        property: String,
        user: String,
    },
    computed: {
        roomTypeDropdown () {
            const isFullWidth = store.breakpoint.includes('s')
            return {
                from: 'right',
                isFullWidth,
                label: 'Room Type',
                labelIsHidden: isFullWidth,
                options: this.roomTypeOptions,
                value: this.roomType,
            }
        },
        slideCount () {
            return store.breakpoint.includes('s') ? 1 : 2
        },
        slideSize () {
            return store.breakpoint.includes('xs') ||
                store.breakpoint === 'md' ||
                    store.breakpoint === 'lg' ? 'base' : 'lg'
        },
    },
    methods: {
        setRoomType (roomType) {
            this.roomType = roomType
            this.updateAvailability()
        },
        updateAvailability () {
            this.isGettingAvailability = true
            const guests = store.guests
            const roomType = this.roomType
            const params = {
                propertyRentalSourceId: this.propertyRentalSourceId,
                numberOfBedrooms: roomType,
                startDate: getDateString(this.startDate),
                endDate: getDateString(this.endDate),
                ...getPartyParams(guests),
            }
            if (typeof this.userId === 'number') {
                params.userId = this.userId
            }
            // a slower answer for an earlier party or room type must not overwrite a newer one
            const requestId = ++this.availabilityRequestId
            getAvailability({ params })
                .then(r => r.json())
                .then(json => {
                    if (requestId !== this.availabilityRequestId) return
                    this.availability = json.results
                    this.isGettingAvailability = false
                })
        },
    },
    // lifecycle
    created () {
        // property
        const { propertyRentalSourceId, roomTypes, minBedrooms, timeZone } = JSON.parse(this.property)
        // dates
        this.startDate = todayAt(timeZone)
        this.endDate = new Date(Date.UTC(
            this.startDate.getUTCFullYear() + 1,
            this.startDate.getUTCMonth(),
            this.startDate.getUTCDate() - 1,
        ))
        this.propertyRentalSourceId = propertyRentalSourceId
        // room types
        this.roomTypeOptions = roomTypes.sort()
            .map(x => ({
                display: x > 0 ? `${x} Bedroom` : x < 0 ? 'Hotel Room' : 'Studio',
                value: x,
            }))
        this.roomTypeOptions.push({ display: 'All', value: null })
        const minBedroomsNum = Number(minBedrooms)
        const hasValidMinBedrooms = minBedrooms !== null
            && Number.isFinite(minBedroomsNum)
            && this.roomTypeOptions.some(o => o.value === minBedroomsNum)
        this.roomType = hasValidMinBedrooms ? minBedroomsNum : null
        // user
        Object.assign(this, JSON.parse(this.user))
        // rate plan
        this.ratePlan = this.points ? 'points' : 'usd'
        // availability: follows the party entered in the search form (store.guests)
        this.availabilityRequestId = 0
        this.updateAvailability()
        this.$watch(() => store.guests, () => this.updateAvailability())
    },
    // misc.
    components: {
        Datepicker: DatepickerComponent,
        Dropdown: DropdownComponent,
    },
}
</script>

<template>
    <div
        class="
            tw:mx-auto
            tw:w-fit
        "
    >
        <Datepicker
            class="tw:relative tw:z-0 tw:mt-6"
            v-bind="{
                isSelectable: false,
                // availability
                availability,
                hasAvailabilityData: !!availability,
                isGettingAvailability,
                // dates
                startDate,
                endDate,
                // rate plan
                ratePlan,
                // slides
                slideCount,
                slideSize
            }"
        >
            <template v-slot:header>
                <Dropdown
                    class="
                        tw:ml-0
                        tw:w-full
                        tw:sm:w-auto
                    "
                    v-bind="roomTypeDropdown"
                    v-on:select="setRoomType($event.detail.value)"
                />
            </template>
        </Datepicker>
    </div>
</template>
